import { useAuthentication } from '../../../../../Login/hooks/useAuthentication';

interface TitleParameters {
    totalUnderWritings: number;
}

export const Title: React.FC<TitleParameters> = ({ totalUnderWritings }) => {
    const { authentication } = useAuthentication();
    if (!authentication?.user) return;

    const { requireUnderwritingFee, requireValuationFee } = authentication.user;

    let title = '';
    if (totalUnderWritings !== 0 && requireUnderwritingFee && requireValuationFee) {
        title = 'Valuation Fee + Underwriting Fee per property.';
    } else if (requireValuationFee || totalUnderWritings === 0) {
        title = 'Valuation Fee per property.';
    } else if (requireUnderwritingFee) {
        title = 'Underwriting Fee per property.';
    } else {
        title = '';
    }

    return (
        <div className='title'>
            Invoice
            <div className='appraisal-invoice-notice'>{title}</div>
        </div>
    );
};
